

    <!-- Social Login Buttons -->
<div class="text-center my-3 position-relative mt-4 mb-5">
    <hr class="my-2">
    <span class="position-absolute top-50 start-50 translate-middle bg-white px-3 text-muted">Or</span>
    </div>
    <div class="d-grid gap-2">
    <button type="button" class="btn btn-outline-secondary" (click)="loginWithSocial('facebook')">
        <i class="fab fa-facebook me-2"></i> Continue with Facebook
    </button>
    <button type="button" class="btn btn-outline-secondary" (click)="loginWithSocial('google')">
        <i class="fab fa-google me-2"></i> Continue with Google
    </button>

 
        <button *ngIf="st === 'email'" type="button" class="btn btn-outline-secondary" (click)="loginWithSocial('whatsapp')">
            <i class="fab fa-whatsapp me-2"></i> Continue with WhatsApp
        </button>
 
        <button *ngIf="st === 'phone'" type="button" class="btn btn-outline-secondary" (click)="loginWithSocial('whatsapp')">
            <i class="fa fa-envelope me-2"></i> Continue with Email
        </button>
 
   
</div>
